import React, { forwardRef, Ref } from 'react';

import { ScrollbarProps } from 'smooth-scrollbar-react';
import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar';

import { StyledScrollbar } from './ComponentScrollbar.styles';

type componentScrollbar = {
  children: React.ReactNode;
  marginBottom?: number;
} & ScrollbarProps;

const ComponentScrollbar = forwardRef(
  (
    { children, className, plugins, onScroll, style, marginBottom }: componentScrollbar,
    ref?: Ref<BaseScrollbar>
  ) => {
    return (
      <StyledScrollbar
        className="global-scrollbar-styles"
        marginBottom={marginBottom}
        plugins={{
          overscroll: {
            effect: 'glow',
          } as const,
        }}
        ref={ref}
        style={{
          zIndex: `1`,
          pointerEvents: `auto`,
        }}
        renderByPixels
      >
        <div>{children}</div>
      </StyledScrollbar>
    );
  }
);

export default ComponentScrollbar;
